import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../../services/utils';

import Actions from '../Actions';

import styles from './page-header.module.css';

const PageHeader = ( {
	actions,
	className = '',
	title
} ) => {
	return (
		<div className={ `${ styles.pageHeader } ${ className }` }>
			{ log( '- pageHeader' ) }
			<h2>
				{ title }
			</h2>
			<Actions actions={ actions } />
		</div>
	);
};

PageHeader.propTypes = {
	actions: PropTypes.arrayOf( PropTypes.shape( {
		action: PropTypes.oneOfType( [
			PropTypes.func,
			PropTypes.object
		] ),
		disable: PropTypes.bool,
		dropdown: PropTypes.bool,
		icon: PropTypes.string,
		text: PropTypes.string
	} ) ),
	className: PropTypes.string,
	title: PropTypes.node
};

export default memo( PageHeader );
